/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CancelAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function CancelAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/Subscription/Content/Content/CancelAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../No'))}
 type="secondary"
 text="Cancel"
/>
{children}
</React.Fragment>)
}